import ListAllCoupons from './list/List';

export default ListAllCoupons;
